import { TYPE_COLLECTION } from './input-types';

export const id = 'warehouseStatus';
export const apiKey = 'PickBatchStatusId';
export const type = TYPE_COLLECTION;

export const warehouseStatus = {
  id,
  apiKey,
  type,
};
